const getCollapsedMessagesIds = (): string[] => {
  try {
    const storedIds = localStorage.getItem('collapsedMessagesIds');
    return storedIds ? (JSON.parse(storedIds) as string[]) : [];
  } catch (error) {
    console.warn(
      'Erreur lors de la lecture du localStorage pour collapsedMessagesIds:',
      error,
    );
    return [];
  }
};

const setCollapsedMessagesIds = (ids: string[]): void => {
  try {
    localStorage.setItem('collapsedMessagesIds', JSON.stringify(ids));
  } catch (error) {
    console.warn(
      "Erreur lors de l'écriture dans le localStorage pour collapsedMessagesIds:",
      error,
    );
  }
};

export const addMessageIdToCollapsedMessagesIds = (id: string) => {
  const collapsedMessagesIds: string[] = getCollapsedMessagesIds();
  if (!collapsedMessagesIds.includes(id)) {
    collapsedMessagesIds.push(id);
    setCollapsedMessagesIds(collapsedMessagesIds);
  }
};

export const checkIfMessageIdIsInCollapsedMessagesIds = (
  id: string,
): boolean => {
  return getCollapsedMessagesIds().includes(id);
};

export const purgeCollapsedMessagesIds = (ids: string[]) => {
  const collapsedMessagesIds = getCollapsedMessagesIds();
  const collapsedMessagesIdsToKeep = ids.filter(id =>
    collapsedMessagesIds.includes(id),
  );
  setCollapsedMessagesIds(collapsedMessagesIdsToKeep);
};
